export function StatCard({ label, value, icon: Icon, caption }) {
  return (
    <article className="stat-card">
      <div className="stat-icon">{Icon ? <Icon size={20} /> : null}</div>
      <div>
        <span>{label}</span>
        <strong>{value}</strong>
        {caption ? <small>{caption}</small> : null}
      </div>
    </article>
  );
}
